/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import {
  ApiAssetCategoryResponse,
  ApiCurrencyRateResponse,
  ApiCurrencyResponse,
  ApiRegionResponse,
} from "./data-contracts";
import { ApiBaseError, HttpClient, RequestParams } from "./http-client";

export class GtwDictionary<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Currencies
   * @name CurrencyControllerGetAllCurrencies
   * @summary Get all available currencies
   * @request GET:/gtw/dictionary/currencies
   * @secure
   * @response `200` `(ApiCurrencyResponse)[]` List of all available currencies.
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  currencyControllerGetAllCurrencies = (params: RequestParams = {}) =>
    this.request<ApiCurrencyResponse[], ApiBaseError>({
      path: `/gtw/dictionary/currencies`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Currencies
   * @name CurrencyControllerFindAllRatesByBaseCurrency
   * @summary Get all currency rates for base currency by code
   * @request GET:/gtw/dictionary/currencies/rates
   * @secure
   * @response `200` `(ApiCurrencyRateResponse)[]` List of currency rates for base currency by code.
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  currencyControllerFindAllRatesByBaseCurrency = (
    query: {
      /* Template custom: data-contract-jsdoc */
      baseCurrency: string;
      /* Template custom: data-contract-jsdoc */
      quoteCurrencies?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiCurrencyRateResponse[], ApiBaseError>({
      path: `/gtw/dictionary/currencies/rates`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Currencies
   * @name CurrencyControllerFindAllRatesByBaseCurrencyId
   * @summary Get all currency rates for base currency by ID
   * @request GET:/gtw/dictionary/currencies/{baseCurrencyId}/rates
   * @secure
   * @response `200` `(ApiCurrencyRateResponse)[]` List of currency rates for base currency by ID.
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  currencyControllerFindAllRatesByBaseCurrencyId = (
    baseCurrencyId: number,
    query?: {
      /* Template custom: data-contract-jsdoc */
      quoteCurrencies?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiCurrencyRateResponse[], ApiBaseError>({
      path: `/gtw/dictionary/currencies/${baseCurrencyId}/rates`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Regions
   * @name RegionControllerFindAll
   * @summary Get list of all regions
   * @request GET:/gtw/dictionary/regions
   * @secure
   * @response `200` `(ApiRegionResponse)[]` List of regions successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  regionControllerFindAll = (params: RequestParams = {}) =>
    this.request<ApiRegionResponse[], ApiBaseError>({
      path: `/gtw/dictionary/regions`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Asset category weight
   * @name AssetCategoryControllerGetAllAssetWeights
   * @summary Get list of all asset weight
   * @request GET:/gtw/dictionary/assets/weights
   * @secure
   * @response `200` `(ApiAssetCategoryResponse)[]` List of all asset weight successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  assetCategoryControllerGetAllAssetWeights = (params: RequestParams = {}) =>
    this.request<ApiAssetCategoryResponse[], ApiBaseError>({
      path: `/gtw/dictionary/assets/weights`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
